module.exports = __webpack_public_path__ + "img/20210906-1630912347998483.8b2d86bd.png";